import EnumDataSource from "utils/enum-data-source.util";

export const RECORDING_STATE_STOPPED = 1;
export const RECORDING_STATE_IN_PROGRESS = 2;
export const RECORDING_STATE_PAUSED = 3;
export const RECORDING_STATE_SAVING = 4;

export const AMBIENT_SCRIBE_STATUS_AWAITING_UPLOAD = 1;
export const AMBIENT_SCRIBE_STATUS_UPLOADING = 2;
export const AMBIENT_SCRIBE_STATUS_UPLOADED = 3;
export const AMBIENT_SCRIBE_STATUS_TRANSCRIBED = 4;
export const AMBIENT_SCRIBE_STATUS_UPLOAD_FAILED = 5;
export const AMBIENT_SCRIBE_STATUS_RECORDING = 0;

export const AMBIENT_SCRIBE_STATUS_PROCESSING = 6;
export const AMBIENT_SCRIBE_STATUS_COMPLETED = 7;
export const AMBIENT_SCRIBE_STATUS_FAILED = 8;
export const AMBIENT_SCRIBE_STATUS_RETRYING = 9;
export const AMBIENT_SCRIBE_STATUS_CANCELLED = 10;
export const AMBIENT_SCRIBE_STATUS_PAUSED = 11;

export const WIDGET_RETURN_LATER_BUTTON_TOOLTIP =
  "Save this recording and return later. Open it from the scribe list to resume recording or complete when you are ready.";

export const AMBIENT_SCRIBE_STATUSES = new EnumDataSource({
  [AMBIENT_SCRIBE_STATUS_RECORDING]: "Recording",
  [AMBIENT_SCRIBE_STATUS_AWAITING_UPLOAD]: "Awaiting Upload",
  [AMBIENT_SCRIBE_STATUS_UPLOADING]: "Uploading…",
  [AMBIENT_SCRIBE_STATUS_UPLOADED]: "Uploaded",
  [AMBIENT_SCRIBE_STATUS_TRANSCRIBED]: "Transcribed",
  [AMBIENT_SCRIBE_STATUS_UPLOAD_FAILED]: "Upload Failed",
  [AMBIENT_SCRIBE_STATUS_PROCESSING]: "Processing",
  [AMBIENT_SCRIBE_STATUS_COMPLETED]: "Completed",
  [AMBIENT_SCRIBE_STATUS_FAILED]: "Failed",
  [AMBIENT_SCRIBE_STATUS_RETRYING]: "Retrying",
  [AMBIENT_SCRIBE_STATUS_CANCELLED]: "Cancelled",
  [AMBIENT_SCRIBE_STATUS_PAUSED]: "Paused"
});

export const AMBIENT_SCRIBE_BACKEND_STATUS_RECORDING = 0;
export const AMBIENT_SCRIBE_BACKEND_STATUS_UPLOADED = 1;
export const AMBIENT_SCRIBE_BACKEND_STATUS_PROCESSING = 2;
export const AMBIENT_SCRIBE_BACKEND_STATUS_TRANSCRIBED = 3;
export const AMBIENT_SCRIBE_BACKEND_STATUS_COMPLETED = 4;
export const AMBIENT_SCRIBE_BACKEND_STATUS_FAILED = 5;
export const AMBIENT_SCRIBE_BACKEND_STATUS_RETRYING = 6;
export const AMBIENT_SCRIBE_BACKEND_STATUS_CANCELLED = 7;
// Paused for later (SN-17727). Backend status code 8 — see docs/ambient-scribes/.
export const AMBIENT_SCRIBE_BACKEND_STATUS_PAUSED = 8;

export const AMBIENT_SCRIBE_BACKEND_STATUSES = new EnumDataSource({
  [AMBIENT_SCRIBE_BACKEND_STATUS_RECORDING]: "Recording",
  [AMBIENT_SCRIBE_BACKEND_STATUS_UPLOADED]: "Uploaded",
  [AMBIENT_SCRIBE_BACKEND_STATUS_PROCESSING]: "Processing",
  [AMBIENT_SCRIBE_BACKEND_STATUS_TRANSCRIBED]: "Transcribed",
  [AMBIENT_SCRIBE_BACKEND_STATUS_COMPLETED]: "Completed",
  [AMBIENT_SCRIBE_BACKEND_STATUS_FAILED]: "Failed",
  [AMBIENT_SCRIBE_BACKEND_STATUS_RETRYING]: "Retrying",
  [AMBIENT_SCRIBE_BACKEND_STATUS_CANCELLED]: "Cancelled",
  [AMBIENT_SCRIBE_BACKEND_STATUS_PAUSED]: "Paused"
});

/** Scribe modal stack: base dialog, popovers/tooltips, nested confirms (above base). */
export const getScribeModalZIndex = (snackbarZ: number) => snackbarZ + 101;
export const getScribeModalPopoverZIndex = (snackbarZ: number) => snackbarZ + 111;
export const getScribeModalNestedDialogZIndex = (snackbarZ: number) =>
  snackbarZ + 112;

// Tab sync action constants
export const TAB_SYNC_ACTIONS = {
  START_SCRIBE_RECORDING_ON_TAB: "START_SCRIBE_RECORDING_ON_TAB",
  RESUME_SCRIBE_RECORDING_ON_TAB: "RESUME_SCRIBE_RECORDING_ON_TAB",
  PAUSE_SCRIBE_RECORDING_ON_TAB: "PAUSE_SCRIBE_RECORDING_ON_TAB",
  STOP_SCRIBE_RECORDING_ON_TAB: "STOP_SCRIBE_RECORDING_ON_TAB",
  REQUEST_RECORDING_STATUS: "REQUEST_RECORDING_STATUS",
  RECORDING_STATUS_RESPONSE: "RECORDING_STATUS_RESPONSE"
} as const;

// Database store names
export const DATABASE_STORES = {
  RECORDINGS: "recordings",
  RECORDINGS_CHUNKS: "recordings_chunks",
  RECORDING_SESSIONS: "recording_sessions"
} as const;

// Database indexes
export const DATABASE_INDEXES = {
  UPLOAD_STATUS: "uploadStatus"
} as const;

// MediaRecorder states
export const MEDIA_RECORDER_STATES = {
  INACTIVE: "inactive",
  RECORDING: "recording",
  PAUSED: "paused"
} as const;

// File types and MIME types
export const AUDIO_CONFIG = {
  MIME_TYPE: "audio/webm",
  FILE_EXTENSION: ".webm"
} as const;

// Favicon paths
export const FAVICON_PATHS = {
  DEFAULT: "/favicon.ico",
  RECORDING: "/favicon-red.ico",
  PAUSED: "/favicon-green.ico"
} as const;

// Recording session ID
export const RECORDING_SESSION_ID = "current";

// Error messages
export const ERROR_MESSAGES = {
  DATABASE_NOT_READY: "Database not ready, cannot start recording",
  UPLOAD_WORKER_NOT_AVAILABLE: "Upload worker not available",
  NO_RECORDING_SESSION_TO_STOP: "No recording session to stop",
  NO_VALID_RECORDING_SESSION_TO_RESUME: "No valid recording session to resume",
  RECORDING_STOPPED_MAX_DURATION:
    "Recording stopped – maximum duration reached",
  RECORDING_CONNECTION_FAILED:
    "Failed to connect to recording service. Please try again.",
  RECORDING_SERVICE_ERROR: "Recording service error. Please try resuming.",
  TRANSCRIPTION_SERVICE_ERROR:
    "Transcription service error occurred during recording."
} as const;

// Success messages
export const SUCCESS_MESSAGES = {
  SCRIBE_RECORD_UPLOADED: "Scribe record uploaded",
  SCRIBE_RECORD_UPLOAD_FAILED: "Scribe record upload failed"
} as const;

// Upload messages
export const UPLOAD_MESSAGES = {
  UPLOADING_AUDIO_SCRIBE_DATA: "Uploading audio scribe data…"
} as const;
